import styled, { css, keyframes } from 'styled-components';

type OverlayProps = {
  visible: boolean;
};

export const Overlay = styled.div<OverlayProps>`
  ${({ visible }) => css`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #0000003d;
    z-index: 25;
    opacity: ${visible ? 1 : 0};
    pointer-events: ${visible ? 'all' : 'none'};
    transition: opacity 250ms ease-in-out;
  `}
`;

export const appear = keyframes`
  from {
    top: 0;
  }
  to {
    top: 5rem;
  }
`;

export const ContainerFluid = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #fff;
  z-index: 50;
  width: 100%;
  /* max-width: 500px; */
`;

export const Container = styled.div`
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 24px;
  height: 72px;
  align-items: center;
`;

export const Title = styled.p`
  color: #555658;
  text-align: left;
  font-size: 16px;
  font-weight: 500;
`;

export const Subtitle = styled.p`
  color: #898b8e;
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  margin-top: 4px;
`;

export const DivTitles = styled.div`
  width: 100%;

  margin: 0px;
`;

export const DivCart = styled.div`
  position: relative;
  cursor: pointer;
  margin: 0px;
  margin-right: 0.5rem;
`;

export const DivBack = styled.div`
  margin-right: 12px;
  cursor: pointer;
  width: 24px;
  height: 24px;
`;

export const CountCart = styled.label`
  position: absolute;
  top: -6px;
  right: -6px;
  padding: 4px;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 600;
  background-color: #ef4f4c;
  color: #fff;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Button = styled.button`
  background-color: transparent;
  border: 1px solid transparent;
`;

export const ContainerMenu = styled.div<OverlayProps>`
  ${({ visible }) => css`
    display: ${visible ? 'flex' : 'none'};
    flex-direction: column;
    position: relative;
    background: #fff;
    animation: ${appear};
    animation-duration: 250ms;

    position: absolute;
    top: 5rem;
    left: 0;
    right: 0;

    & .services-list {
      max-height: var(--height-body-without-header);
      overflow-y: auto;
    }
  `}
`;

export const LineCart = styled.div`
  height: 1px;
  background: #d5d5d6;
  margin: 0 32px;
  margin-bottom: 16px;
`;

export const CartItemWrapper = styled.div`
  margin: 10px 0;
  padding: 0 32px;
  display: flex;
  align-items: center;
`;

export const CartEmpty = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0;
`;

export const TitleEmpty = styled.p`
  text-align: left;
  font-size: 14px;
  font-weight: 400;
  color: #898b8e;
`;

export const IconEmpty = styled.div`
  background: #f7f7f7;
  padding: 5px 20px;
  font-size: 32px;
  color: #898b8e;
  font-weight: 600;
  border-radius: 100%;
`;
